// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MemoPromptsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MemoPromptsQuery = { __typename?: 'Query', defaultMemoPrompts: Array<{ __typename?: 'DefaultMemoPrompt', memoType: Types.MemoPromptMemoPromptType, promptText: string }>, roleSummaryPredicateOptions: Array<{ __typename?: 'RoleSummaryPredicateOption', key: string, label: string, predicates: Array<string> }> };

export const Operations = {
  Query: {
    MemoPrompts: 'MemoPrompts' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const MemoPromptsDocument = gql`
    query MemoPrompts {
  defaultMemoPrompts {
    memoType
    promptText
  }
  roleSummaryPredicateOptions {
    key
    label
    predicates
  }
}
    `;

/**
 * __useMemoPromptsQuery__
 *
 * To run a query within a React component, call `useMemoPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemoPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemoPromptsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMemoPromptsQuery(baseOptions?: Apollo.QueryHookOptions<MemoPromptsQuery, MemoPromptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemoPromptsQuery, MemoPromptsQueryVariables>(MemoPromptsDocument, withFetchPolicyContext(options));
      }
export function useMemoPromptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemoPromptsQuery, MemoPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemoPromptsQuery, MemoPromptsQueryVariables>(MemoPromptsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useMemoPromptsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MemoPromptsQuery, MemoPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemoPromptsQuery, MemoPromptsQueryVariables>(MemoPromptsDocument, withFetchPolicyContext(options));
        }
export type MemoPromptsQueryHookResult = ReturnType<typeof useMemoPromptsQuery>;
export type MemoPromptsLazyQueryHookResult = ReturnType<typeof useMemoPromptsLazyQuery>;
export type MemoPromptsSuspenseQueryHookResult = ReturnType<typeof useMemoPromptsSuspenseQuery>;
export type MemoPromptsQueryResult = Apollo.QueryResult<MemoPromptsQuery, MemoPromptsQueryVariables>;